export default __webpack_public_path__ + "static/identity1b-60a0157bc5780df9a4017d6beb219832.jpg";